!function() {
  var __webpack_modules__ = {
    334: function(module) {
      function debounce(function_, wait = 100, options = {}) {
        if ("function" != typeof function_) throw new TypeError(`Expected the first parameter to be a function, got \`${typeof function_}\`.`);
        if (wait < 0) throw new RangeError("`wait` must not be negative.");
        const {immediate: immediate} = "boolean" == typeof options ? {
          immediate: options
        } : options;
        let storedContext, storedArguments, timeoutId, timestamp, result;
        function run() {
          const callContext = storedContext, callArguments = storedArguments;
          return storedContext = void 0, storedArguments = void 0, result = function_.apply(callContext, callArguments), 
          result;
        }
        function later() {
          const last = Date.now() - timestamp;
          last < wait && last >= 0 ? timeoutId = setTimeout(later, wait - last) : (timeoutId = void 0, 
          immediate || (result = run()));
        }
        const debounced = function(...arguments_) {
          if (storedContext && this !== storedContext) throw new Error("Debounced method called with different contexts.");
          storedContext = this, storedArguments = arguments_, timestamp = Date.now();
          const callNow = immediate && !timeoutId;
          return timeoutId || (timeoutId = setTimeout(later, wait)), callNow && (result = run()), 
          result;
        };
        return debounced.clear = () => {
          timeoutId && (clearTimeout(timeoutId), timeoutId = void 0);
        }, debounced.flush = () => {
          timeoutId && debounced.trigger();
        }, debounced.trigger = () => {
          result = run(), debounced.clear();
        }, debounced;
      }
      module.exports.debounce = debounce, module.exports = debounce;
    },
    837: function() {
      window.Shopify = window.Shopify || {}, window.Shopify.MultiStore = [ {
        storeCode: "GB",
        storeName: "United Kingdom",
        storeUrl: "https://www.davidaustinroses.co.uk",
        supportedLanguages: "EN",
        supportedCurrencies: "GBP",
        currencySymbol: "£",
        supportedStores: "GB"
      }, {
        storeCode: "DE",
        storeName: "Germany",
        storeUrl: "https://de.davidaustinroses.com",
        supportedLanguages: "DE",
        supportedCurrencies: "EUR",
        currencySymbol: "€",
        supportedStores: "AT,DE"
      }, {
        storeCode: "EU",
        storeName: "Europe",
        storeUrl: "https://eu.davidaustinroses.com",
        supportedLanguages: "EN",
        supportedCurrencies: "EUR",
        currencySymbol: "€",
        supportedStores: "AD,AL,AM,AX,BA,BE,BG,BY,CH,CY,CZ,DK,EE,ES,FI,FO,FR,GE,GI,GR,HR,HU,IE,IS,IT,LT,LU,LV,MC,MK,MT,NL,NO,PL,PT,RO,SE,SI,SK,SM,UA,VA,CH"
      }, {
        storeCode: "US",
        storeName: "United States",
        storeUrl: "https://www.davidaustinroses.com",
        supportedLanguages: "EN",
        supportedCurrencies: "USD",
        currencySymbol: "$",
        supportedStores: "US"
      }, {
        storeCode: "JP",
        storeName: "Japan",
        storeUrl: "https://www.davidaustinroses.co.jp",
        supportedLanguages: "JA",
        supportedCurrencies: "JPY",
        currencySymbol: "¥",
        supportedStores: "JP"
      }, {
        storeCode: "AU",
        storeName: "Australia",
        storeUrl: "https://www.davidaustinrosesaustralia.com",
        supportedLanguages: "EN",
        supportedCurrencies: "AUD",
        currencySymbol: "$",
        supportedStores: "AU"
      } ];
    }
  }, __webpack_module_cache__ = {};
  function __webpack_require__(moduleId) {
    var cachedModule = __webpack_module_cache__[moduleId];
    if (void 0 !== cachedModule) return cachedModule.exports;
    var module = __webpack_module_cache__[moduleId] = {
      exports: {}
    };
    return __webpack_modules__[moduleId](module, module.exports, __webpack_require__), 
    module.exports;
  }
  __webpack_require__.n = function(module) {
    var getter = module && module.__esModule ? function() {
      return module.default;
    } : function() {
      return module;
    };
    return __webpack_require__.d(getter, {
      a: getter
    }), getter;
  }, __webpack_require__.d = function(exports, definition) {
    for (var key in definition) __webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key) && Object.defineProperty(exports, key, {
      enumerable: !0,
      get: definition[key]
    });
  }, __webpack_require__.o = function(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }, function() {
    "use strict";
    __webpack_require__(837);
    var debounce = __webpack_require__(334), debounce_default = __webpack_require__.n(debounce);
    new class {
      loading=[];
      header=document.querySelector("header");
      async importScript(el) {
        const tagName = el.tagName.toLowerCase(), devMode = "127.0.0.1" === location.hostname || Shopify && Shopify.theme && -1 !== Shopify.theme.name.indexOf("Development") || Shopify.designMode;
        if (-1 === this.loading.indexOf(tagName) && (this.loading.push(tagName), !customElements.get(tagName))) {
          var scriptTag = document.createElement("script");
          scriptTag.src = `${window.settings.asset_url || "/assets/"}${tagName}.js?v=${devMode ? Date.now() : window.settings.asset_revision || Date.now()}`, 
          scriptTag.async = !0, devMode && (scriptTag.onload = () => console.info(`Loaded: ${tagName}`)), 
          scriptTag.onerror = () => console.warn(`Failed to load ${tagName}.`) && this.loading.splice(this.loading.indexOf(tagName)), 
          document.body.appendChild(scriptTag);
        }
      }
      loadScript(el) {
        if (el.hasAttribute("data-autoload")) this.importScript(el); else {
          new IntersectionObserver((async (entries, observer) => {
            entries.forEach((async entry => {
              entry.isIntersecting && (this.importScript(el), observer.disconnect());
            }));
          }), {
            rootMargin: "0px 0px 100% 0px"
          }).observe(el);
        }
      }
      initJavascript() {
        document.querySelectorAll("[data-async]").forEach((el => this.loadScript(el)));
        new MutationObserver(((mutationsList, observer) => {
          mutationsList.forEach((mutation => {
            mutation.target.querySelectorAll("[data-async]").forEach((el => this.loadScript(el)));
          }));
        })).observe(document.querySelector("body"), {
          childList: !0,
          subtree: !0,
          characterData: !1,
          attributes: !1
        });
      }
      initCloser() {
        document.addEventListener("keydown", (event => {
          "Escape" === event.key && document.querySelectorAll('[type="checkbox"][hidden].peer,[type="checkbox"].hidden.peer').forEach((el => el.checked = !1)), 
          document.body.classList.remove("overflow-hidden");
        }));
      }
      initScrollLock() {
        const scrollLock = () => setTimeout((() => [ ...document.querySelectorAll("[data-locker]") ].filter((el => el.checked)).length ? document.body.classList.add("overflow-hidden") : document.body.classList.remove("overflow-hidden")), 100);
        document.body.addEventListener("input", (() => debounce_default()(scrollLock(), 300))), 
        document.body.addEventListener("click", (() => debounce_default()(scrollLock(), 300)));
      }
      initClicks() {
        document.body.addEventListener("click", (event => {
          switch (event.target.tagName.toUpperCase()) {
           case "LABEL":
            (target = document.getElementById(event.target.getAttribute("for"))) && target.hasAttribute("hidden") && (event.preventDefault(), 
            event.stopPropagation(), target.checked = !target.checked);
            break;

           case "INPUT":
            "Search" == event.target.id && event.target.checked && (event.target.checked = !1);
            break;

           case "BUTTON":
           case "A":
            if (event.target.getAttribute("href")?.match(/\/cart$/) && !event.target.closest("shopping-cart")) {
              event.preventDefault();
              const cartToggle = document.querySelector("#Cart");
              cartToggle.checked = !cartToggle.checked, cartToggle.checked && document.getElementById("CartDrawer")?.focus();
              const data = document.querySelector("[data-track-cart]")?.textContent, cart = data ? JSON.parse(data) : null;
              Shopify.analytics.publish("custom_cart_viewed", {
                cart: cart
              });
            } else if (event.target.hasAttribute("data-popup") && document.getElementById(event.target.getAttribute("data-popup")) || event.target.hasAttribute("data-popup") && document.querySelector(`input#${event.target.getAttribute("data-popup")}`)) {
              const target = document.getElementById(event.target.getAttribute("data-popup"));
              target && (event.preventDefault(), target.checked = !0);
            } else if ("#Chat" === event.target.getAttribute("href")) event.preventDefault(), 
            document.querySelector(".vngage-banner:not(.vngage-expand) .vngage-tab")?.click(); else if (event.target.getAttribute("href")?.match(/^#/) && "#" !== event.target.getAttribute("href")) {
              var target;
              (target = document.querySelector(event.target.getAttribute("href"))) && (event.preventDefault(), 
              window.scrollTo({
                top: target.offsetTop - this.header?.clientHeight,
                left: 0,
                behavior: "smooth"
              }));
            }
          }
        }));
      }
      trackRecentlyViewed() {
        Shopify = Shopify || {}, Shopify.recentlyViewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];
        const url = location.href.match("/products/([^?#]+)");
        url && !Shopify.recentlyViewed.includes(url[1]) && (Shopify.recentlyViewed.unshift(url[1]), 
        Shopify.recentlyViewed = Shopify.recentlyViewed.slice(0, 8), localStorage.setItem("recentlyViewed", JSON.stringify(Shopify.recentlyViewed)));
      }
      visualViewport() {
        document.documentElement.style.setProperty("--visual-viewport", `${window.visualViewport.height}px`), 
        document.documentElement.style.setProperty("--header-height", `${document.querySelector("header")?.clientHeight}px`);
      }
      constructor() {
        window.Shopify = window.Shopify || {}, Shopify.debounce = debounce_default(), this.initJavascript(), 
        this.initCloser(), this.initClicks(), this.trackRecentlyViewed(), document.addEventListener("DOMContentLoaded", (() => {
          this.visualViewport(), (window.visualViewport || window).addEventListener("resize", debounce_default()(this.visualViewport, 300), {
            passive: !0
          });
        }));
      }
    }, window.Geo = new class {
      cookie=!1;
      cookieSelector="geolocation";
      isCurrentStore(option) {
        return option.storeCode === window.settings.storeCode;
      }
      getRedirectOptionTemplate() {
        return Shopify.MultiStore.map((option => "FR" === option.storeCode ? "" : `\n        <option\n          value="${option.storeCode}"\n          data-store-code="${option.storeCode}"\n          data-store-url="${option.storeUrl}"\n          ${this.isCurrentStore(option) ? "selected" : ""}\n        >\n          ${option.storeName} (${option.currencySymbol})\n        </option>`)).join("");
      }
      getRedirectURL(storeCode) {
        const matchingStore = Shopify.MultiStore.filter((element => element.storeCode === storeCode))[0];
        return matchingStore ? `${matchingStore.storeUrl.replace(/\/$/, "")}${window.Geo.checkRedirectMetafields(storeCode)}` : null;
      }
      checkRedirectMetafields(storeCode) {
        if (!window.redirect) return "/";
        let redirectPath;
        for (const [selectedCode, value] of Object.entries(window.redirect)) storeCode === selectedCode && value && (redirectPath = "/" === value.charAt(0) ? value : `/${value}`);
        return redirectPath || "/";
      }
      setGeolocationCookie(response) {
        sessionStorage.setItem(this.cookieSelector, JSON.stringify(response));
      }
      getGeolocationCookie() {
        const cookie = sessionStorage.getItem(this.cookieSelector);
        return !(!cookie || !JSON.parse(cookie).detected_values?.country_name) && JSON.parse(cookie);
      }
      getCountryName() {
        return this.cookie.detected_values.country.name;
      }
      getCountryCode() {
        return this.cookie.detected_values.country.handle;
      }
      async init() {
        let callback = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        fetch(Shopify.routes.root + "browsing_context_suggestions.json").then((response => response.json())).then((json => {
          this.cookie = json, this.setGeolocationCookie(json), callback && callback(json);
        })).catch((error => {
          console.warn(error);
        }));
      }
      getLocation() {
        let callback = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        this.cookie = this.getGeolocationCookie(), this.cookie || this.init(callback);
      }
      constructor() {
        window.Geo = this;
      }
    };
  }();
}();